import styled from '@emotion/styled'

import { getArcadeContentStyle } from '../../styles/content'

const ArcadeStructuredContent = styled.div`
  ${props => getArcadeContentStyle(props.theme)}
`

export default ArcadeStructuredContent
